import { render } from "./PaginateBlock.vue?vue&type=template&id=e764dbbe"
import script from "./PaginateBlock.vue?vue&type=script&lang=js"
export * from "./PaginateBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__